import { getKeys } from './getKeys'

export const serviceRecordTranslations = {
  // Page Header
  SERVICE_RECORDS: 'Service Records',
  ADD_SERVICE_RECORD: 'Add Service Record',
  SERVICE_RECORDS_TOOLTIP:
    "Capture services provided to support a person's needs, including health, social care, and other practical support such as transport, education, or daily living assistance.",

  // Modal
  SERVICE_RECORD: 'Service record',
  TITLE: 'Title',
  TITLE_REQUIRED: 'Title is required',
  TITLE_PLACEHOLDER: 'Enter service record title',
  DESCRIPTION_OF_SERVICE_RECORD: 'Description of service record',
  DESCRIPTION_PLACEHOLDER: 'Enter service record description (optional)',
  DATE_OF_SERVICE_RECORD: 'Date of service record',
  DATE_TIME_PLACEHOLDER: 'Select date and time',
  CANCEL: 'Cancel',
  SAVE: 'Save',
  ADD: 'Add',

  // List
  NO_SERVICE_RECORDS_FOUND: 'No service records found',
  NO_SERVICE_RECORDS_DESCRIPTION:
    'There are no service records recorded for this resident yet.',
  NO_DATE_TIME_SPECIFIED: 'No date/time specified',
  ARCHIVED_SERVICE_RECORDS: 'Archived Service Records',

  // Actions
  VIEW: 'View',
  EDIT: 'Edit',
  ARCHIVE: 'Archive',
  ARCHIVED: 'Archived',
  ACTIVE: 'Active',
  UN_ARCHIVE: 'Un-archive',
  RESTORE: 'Restore',
  SHOW_MORE: 'Show more',
  SHOW_LESS: 'Show less',
  CREATED_BY: 'Created by',
  UPDATED_BY: 'Updated by',

  // Archive Modal
  ARCHIVE_SERVICE_RECORD: 'Archive Service Record',
  RESTORE_SERVICE_RECORD: 'Restore Service Record',
  ARCHIVE_CONFIRMATION:
    'Are you sure you want to archive this service record? You can restore it later if needed.',
  RESTORE_CONFIRMATION:
    'Are you sure you want to restore this service record to active status?'
}

export const serviceRecordConstants = getKeys(serviceRecordTranslations)
